"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Attachment = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Attachment = function Attachment() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.89 2.69c2.313-2.253 6.095-2.253 8.407 0a5.537 5.537 0 010 7.99l-6.94 6.767c-1.564 1.523-4.13 1.524-5.693 0a3.7 3.7 0 010-5.344l5.583-5.444a1.513 1.513 0 012.02-.05 1.25 1.25 0 01.053 1.866L9.737 13.92a1.203 1.203 0 000 1.712 1.096 1.096 0 001.546 0l6.94-6.766a3.041 3.041 0 000-4.359 3.05 3.05 0 00-4.259 0m0 0L6.34 11.941a4.88 4.88 0 000 7.004 5.003 5.003 0 006.973 0l5.364-5.23a1.513 1.513 0 012.02-.05 1.25 1.25 0 01.054 1.866l-5.364 5.23c-3.061 2.985-8.06 2.985-11.12 0a7.375 7.375 0 010-10.636L11.89 2.69",
    clipRule: "evenodd"
  });
};

exports.Attachment = Attachment;